import { Box, Button, Grid, IconButton, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import React, { useEffect, useLayoutEffect, useState } from 'react'
import cart from '../Assets/Image/Cart.png'
import like from '../Assets/Image/LikeIcon.png'
import filledlike from '../Assets/Image/filledheart.png'
import { useLocation, useParams } from 'react-router-dom';
import { Product } from '../Models/Products';
import { Variant } from '../Models/Varient';
import { number } from 'yup';
import { Color } from '../Models/Color';
import { Size } from '../Models/Size';
import { ApiAddToCart, ApiAddToWishlist, ApiGetAllProducts, ApiGetCartlist, ApiGetWishlist, ApiRemoveWishlist } from '../Core/Apicall';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { setCartList, setWishList } from '../Redux/Reducers/globalSlice';
import { RootState } from '../Redux/store';
import { Add, Remove } from '@mui/icons-material'

const sizes = ['UK 6', 'UK 7', 'UK 8', 'UK 9', 'UK 10', 'UK 11', 'UK 12'];

function ProductDetails() {
    const [selectedSize, setSelectedSize] = useState<number>();
    const [selectedColor, setSelectedColor] = useState<number>();
    const [selectedVarient, setSelectedVarient] = useState<Variant>()
    const [availableSize, setAvailableSizes] = useState<Size[]>([])
    const [availableColor, setAvailableColors] = useState<Color[]>([])
    const [activeImage, setActiveImage] = useState(0);
    const { state } = useLocation();
    const { sku } = useParams();
    // const product: Product = state?.product;
    const [product, setProduct] = useState<Product>()
    const dispatch = useDispatch()
    const { userDetails } = useSelector((state: RootState) => state.global)
    const [quantity, setQuantity] = useState(1);

    const handleDecrease = () => {
        if (quantity > 1) {
            setQuantity(quantity - 1);
        }
    };

    const handleIncrease = () => {
        setQuantity(quantity + 1);
    };


    // console.log("Product Details", product)
    const handleChange = (
        _: React.MouseEvent<HTMLElement>,
        newSize: number | null
    ) => {
        if (newSize !== null) {
            setSelectedSize(newSize);
        }
    };

    const handleColor = (
        _: React.MouseEvent<HTMLElement>,
        newColor: number
    ) => {
        if (newColor !== null) {
            setSelectedColor(newColor);
            const uniqueSizes = Array.from(
                new Map(
                    product?.variants
                        ?.filter((item: Variant) => item?.color?.colorId === newColor)
                        ?.map((item: Variant) => [item.size.sizeId, item.size])
                ).values()
            );

            console.log(uniqueSizes);
        }
    };


    useLayoutEffect(() => {
        if (selectedColor) {
            const uniqueSizes = Array.from(
                new Map(
                    product?.variants
                        ?.filter((item: Variant) => item?.color?.colorId === selectedColor && item?.stock > 0)
                        ?.map((item: Variant) => [item.size.sizeId, item.size])
                ).values()
            );
            setAvailableSizes(uniqueSizes)
            setSelectedSize(uniqueSizes[0].sizeId)
        }
    }, [selectedColor])


    useLayoutEffect(() => {
        const uniqVariant = product?.variants?.find((item: Variant) => item?.color.colorId == selectedColor && item.size.sizeId)
        setSelectedVarient(uniqVariant)
    }, [selectedColor, selectedSize])

    const handleImageClick = (clickedIndex: number) => {
        setActiveImage(clickedIndex);
    };

    useLayoutEffect(() => {
        if (product) {
            setSelectedVarient(product?.variants[0])
            setSelectedSize(product?.variants[0].size.sizeId)
            setSelectedColor(product?.variants[0].color.colorId)
            const uniqueColors = Array.from(
                new Map(
                    product?.variants?.map((item: Variant) => [item.color.colorId, item.color])
                ).values()
            );

            // const uniqueSizes = Array.from(
            //     new Map(
            //         product?.variants?.map((item: Variant) => [item.size.sizeId, item.size])
            //     ).values()
            // );

            setAvailableColors(uniqueColors);
            // setAvailableSizes(uniqueSizes);
        }
    }, [product])


    const getProductDetails = async () => {
        try {
            const data = `?sku=${sku}`
            const res = await ApiGetAllProducts(data)
            if (res?.success) {
                setProduct(res?.data[0])
            }
        } catch (error: any) {
            console.log("Error", error)
            toast.error(error?.message || "Something went wrong");
        }
    }

    useLayoutEffect(() => {
        sku && getProductDetails()
    }, [sku])

    const AddtoWishlist = async () => {
        if (!userDetails) { toast.error("Login is required to add product in wishlist"); return; }

        try {
            const data = { productId: product?.productId }
            const data2 = `?productId=${product?.productId}`
            const res = product?.isAddedToWishlist ? await ApiRemoveWishlist(data2) : await ApiAddToWishlist(data)
            if (res?.success) {
                GetWishlist()
                getProductDetails()
            }
        } catch (error: any) {
            console.log("Error", error)
            toast.error(error?.message || "Something went wrong");
        }
    }

    const GetWishlist = async () => {
        try {
            const res = await ApiGetWishlist()
            if (res?.success) {
                dispatch(setWishList(res?.data))
            }
        } catch (error: any) {
            console.log("Error", error)
            toast.error(error?.message || "Something went wrong");
        }
    }
    const GetCartlist = async () => {
        try {
            const res = await ApiGetCartlist()
            if (res?.success) {
                dispatch(setCartList(res?.data))
            }
        } catch (error: any) {
            console.log("Error", error)
            toast.error(error?.message || "Something went wrong");
        }
    }

    const AddProductToCart = async () => {
        try {
            const data = {
                "productId": product?.productId,
                "variantId": selectedVarient?.variantId,
                "quantity": quantity
            }
            const res = await ApiAddToCart(data)
            if (res?.success) {
                GetCartlist()
            }
        } catch (error: any) {
            console.log("Error", error)
            toast.error(error?.message || "Something went wrong");
        }
    }

    return (
        <Box className='h-content w-100 p-3 p-md-5'>
            <Grid container spacing={2} >
                <Grid size={{ xs: 12, md: 6 }}>
                    <Box
                        component="img"
                        className='py-2'
                        src={selectedVarient?.variantImages?.[activeImage]?.image_url}
                        sx={{
                            width: "100%",
                            height: "500px",
                            objectFit: "contain",
                            borderRadius: 2,
                            border: '1px solid #dddddd5A',
                        }}
                    />

                    {/* Thumbnails */}
                    <Grid container spacing={2} sx={{ mt: 2 }}>
                        {selectedVarient?.variantImages
                            ?.filter((_, index) => index !== activeImage)
                            .map((item, index) => (
                                <Grid key={index} size="auto">
                                    <Box
                                        component="img"
                                        src={item.image_url}
                                        onClick={() => {
                                            const actualIndex = selectedVarient.variantImages.findIndex(
                                                img => img.image_url === item.image_url
                                            );
                                            setActiveImage(actualIndex);
                                        }}
                                        sx={{
                                            width: 120,
                                            height: 120,
                                            objectFit: "contain",
                                            cursor: "pointer",
                                            border: "1px solid #dddddd5A",
                                            borderRadius: 2,
                                        }}
                                    />
                                </Grid>
                            ))}
                    </Grid>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Typography className='text-white fs-24 fw-bold mb-2' gutterBottom>{selectedVarient?.name}</Typography>
                    {/* <Typography className='text-grey fs-18 fw-bold mb-1' gutterBottom>Men Nike Air Max 270 Multi Colour Football Shoes</Typography> */}
                    {/* <Typography className='text-white fs-24 fw-bold mb-3' gutterBottom>${selectedVarient?.discounted_price} <span className='text-grey ms-1 fs-20 text-overline'> ${selectedVarient?.price}</span></Typography> */}
                    <Typography className='text-white fw-bold fs-24 align-items-baseline'>${product?.discounted_price} {Number(product?.discount_percentage) > 0 && (<span className='over-line fs-20'>${product?.base_price}</span>)} {Number(product?.discount_percentage) > 0 && (<span className='text-green'>&nbsp;{Number(product?.discount_percentage).toFixed(0)}% off</span>)}</Typography>

                    <hr className='w-100 border-white' />
                    <Typography className='fs-16 text-white fw-bold'>SELECT SIZE</Typography>

                    <ToggleButtonGroup
                        value={selectedSize}
                        exclusive
                        onChange={handleChange}
                        className='select-size'
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 1.5,
                            '& .MuiToggleButtonGroup-grouped': {
                                margin: 0,
                                border: 'none',
                                borderRadius: '999px !important',
                            },
                        }}
                    >
                        {availableSize?.map((item: Size) => (
                            <ToggleButton
                                className='px-4 py-2 fs-16 mt-3 text-white border-grey'
                                key={item?.sizeId}
                                value={item?.sizeId}
                            >
                                {item?.name}
                            </ToggleButton>
                        ))}
                    </ToggleButtonGroup>

                    <hr className='w-100 border-white' />
                    <Typography className='fs-16 text-white fw-bold'>Select Color</Typography>
                    <Box className='select-variant'>
                        <ToggleButtonGroup
                            value={selectedColor}
                            exclusive
                            onChange={handleColor}
                            className='select-variant p-0 border-10'
                            sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: 1.5,
                            }}
                        >
                            {availableColor?.map((color: Color) => (
                                <ToggleButton
                                    className=' p-0 m-0 mt-3 border-0'
                                    sx={{ borderRadius: "50% !important" }}
                                    key={color.colorId}
                                    value={color.colorId}
                                >
                                    <Box sx={{ height: '30px', width: '30px', borderRadius: '50%', backgroundColor: color.hex_code }}></Box>
                                    {/* <Box component={'img'} src={varient?.variantImages?.[0]?.image_url} height={'100px'} className='w-100 border-10' /> */}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </Box>

                    <hr className='w-100 border-white' />
                    <Box className='mt-3'>
                        <Typography className='fs-16 text-white fw-bold mb-3'>Quantity</Typography>
                        <Box sx={{ width: 'fit-content' }} className='d-flex align-items-center border border-10 border-main overflow-hidden'
                        >
                            <IconButton
                                onClick={handleDecrease}
                                disabled={quantity === 1}
                                sx={{ borderRadius: 0 }}
                            >
                                <Remove sx={{ color: 'white' }} />
                            </IconButton>

                            <Typography className='text-white text-center fw-bold mx-2'
                            >
                                {quantity}
                            </Typography>

                            <IconButton
                            disabled={quantity === Number(selectedVarient?.stock) }
                                onClick={handleIncrease}
                                sx={{ borderRadius: 0 }}
                            >
                                <Add sx={{ color: 'white' }} />
                            </IconButton>
                        </Box>
                    </Box>

                    <Box className='d-flex align-items-center gap-3 my-4'>
                        <Button onClick={()=>{AddProductToCart()}} className='d-flex align-items-center gap-4 border-10 px-3 py-2 btn-main'> <span className='fs-16 text-white'>Add to Bag</span> <Box component={'img'} src={cart} height={'20px'} width={'20px'} /></Button>
                        <Button className={`d-flex align-items-center gap-5 border-10 px-3 py-2 ${product?.isAddedToWishlist ? "border-yellow text-yellow" : "border-white text-white"} transform`} variant='outlined' onClick={AddtoWishlist}> <span className='fs-16'>Wishlist</span> <Box component={'img'} src={product?.isAddedToWishlist ? filledlike : like} height={'20px'} width={'20px'} /></Button>
                    </Box>
                    <hr className='w-100 border-white' />
                    <Box>
                        <Typography className='fs-14 text-white fw-bold mb-2' gutterBottom>PRODUCT DESCRIPTION</Typography>
                        <Typography className='fw-bold text-white fs-12'>
                            {product?.description}
                        </Typography>
                    </Box>

                </Grid>
            </Grid>
        </Box>
    )
}

export default ProductDetails
